import FlagProvider from '@unleash/proxy-client-react';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import 'driver.js/dist/driver.css';
import App from './App';
import { unleashProxyConfig } from './unleash-proxy';
import { UnleashClient } from '@unleash/proxy-client-react';
import { addToast } from './store/ducks/toast/actions';
import { EToastTypes } from './store/ducks/toast/types';
import store from './store';
import { setAppConnectivity } from './store/ducks/connectivity/actions';

const wrappedFetch: typeof fetch = async (...args) => {
  try {
    return await fetch(...args);
  } catch (err) {
    return new Response(null, {
      status: 304,
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-store',
        ETag: 'offline'
      }
    });
  }
};

function AppWrapper() {
  const dispatch = (e: any) => store.dispatch(e);
  const client = new UnleashClient({
    ...unleashProxyConfig,
    fetch: wrappedFetch
  });

  useEffect(() => {
    window.addEventListener('online', () => {
      client.start();
      dispatch(setAppConnectivity(true));
      dispatch(
        addToast({
          message: 'Conexão com a internet restabelecida',
          type: EToastTypes.SUCCESS,
          durationInMS: 5000,
          spaceToTop: 80
        })
      );
    });
    window.addEventListener('offline', () => {
      client.stop();
      dispatch(setAppConnectivity(false));
      dispatch(
        addToast({
          message: 'Verifique sua conexão à internet, não recarregue a página',
          type: EToastTypes.WARNING,
          durationInMS: 5000,
          spaceToTop: 80
        })
      );
    });

    if (window.navigator.onLine) {
      client.start();
    }
  }, []);

  return (
    <FlagProvider unleashClient={client}>
      <App />
    </FlagProvider>
  );
}

ReactDOM.render(
  // <React.StrictMode>
  <AppWrapper />,
  // </React.StrictMode>,
  document.getElementById('root')
);
